function VueDirective(app) {
  /***
   * 選單類浮窗，點擊其物件之外的範圍，自動藏隱
   */
  app.directive('click-outside', {
    mounted(el, binding) {
      //if (typeof binding.value !== 'function') {
        //const compName = vNode.context.name;
        //let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
        //if (compName) {
        //  warn += `Found in component '${compName}'`;
        //}
      //}
      const bubble = binding.modifiers.bubble;

      const handler = (e) => {
        if (bubble || (!el.contains(e.target) && el !== e.target)) {
          binding.value();
        }
      };
      el.__vueClickOutside__ = handler;

      document.addEventListener('click', handler);
    },
    // eslint-disable-next-line no-unused-vars
    unmounted(el, binding) {
      document.removeEventListener('click', el.__vueClickOutside__);
      el.__vueClickOutside__ = null;
    },
  });
}

export default VueDirective;
